// Feature switches. Setting one to false hides the section everywhere it is reachable:
// navigation (desktop and mobile), the dashboard cards and its route (redirected to the overview).
export const FEATURES = {
  // Crops Analysis: Crops Impact Analysis and Risk-Based Crops Analysis (/dashboard/risk-indices-2).
  // Hidden temporarily; set to true to show it again.
  cropsAnalysis: false,
} as const;

export type FeatureName = keyof typeof FEATURES;
